import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, FormLabel, Input, Stack, TextareaAutosize } from '@mui/material';
import useBundleTranslation from 'i18n';
import { IItemFlowProps } from '../item-wrapper/index';

interface DataSet {
    promptText: string;
}

export default function CallSearch({ workflowItemSettings, saveItemSettings }: IItemFlowProps) {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);

    const initialData: DataSet = {
        promptText: '',
    };

    try {
        const tmp: any = JSON.parse(workflowItemSettings);
        if (tmp?.promptText) initialData.promptText = tmp.promptText;
    } catch (e) {}

    const [promptText, setPromptText] = useState(initialData.promptText);

    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        saveItemSettings({
            promptText,
        });
    }, [promptText]);

    return (
        <Stack>
            <Box>
                <FormLabel>{t('promptText')}</FormLabel>
                <Box>
                    <TextareaAutosize
                        style={{ width: '100%' }}
                        minRows={5}
                        maxRows={20}
                        onChange={(event) => {
                            setPromptText(event.target.value);
                        }}
                        value={promptText}
                    />
                </Box>
            </Box>
        </Stack>
    );
}
